import { defineNuxtPlugin } from '#app/nuxt';
import { useBlockEditorLibrary } from '#layers/block-engine/public';

function getFieldDisplayBlock(id: string) {
	return useBlockEditorLibrary().getBlock(id);
}

function isFieldDisplayBlockResolverReady() {
	return useBlockEditorLibrary().isReady.value;
}

export default defineNuxtPlugin(() => {
	return {
		provide: {
			fieldDisplayBlockResolver: {
				getBlock: getFieldDisplayBlock,
				isReady: isFieldDisplayBlockResolverReady,
			},
		},
	};
});
